module.exports = __webpack_public_path__ + "static/flowchart-2-9d555401809fac0bb38b19fd5b71102b.png";